<template>
	<div class="admin" style="background-color: #f5f5f5;height: 700px;">
		<h3 style="padding: 15px 0px;">用户管理</h3>
		<div style="width: 100%;background-color: white;height: 5px;"></div>
		<div class="userlist middle-row start">
			<div v-for="(login,i) in loginlist" :key="i" class="user middle-row around">
				<div class="userleft middle-row center" style="width: 20%;">
					<i :class="login.usertype=='系统管理员'?'classone':'classtwo'" class="fa fa-user-circle fa-4x"></i>
				</div>
				<div class="usermiddle middle-column around" style="width: 45%;align-items: flex-start;">
					<h5>名称:{{login.username}}</h5>
					<h5>街道:{{login.street}}</h5>
					<h5>类型:{{login.usertype}}</h5>
				</div>
				<div class="userright middle-column around" style="width: 30%;">
					<a class="btn btn-warning" name="btn" @click="deleteUser(i)">删除账户</a>
					<a class="btn btn-success" name="btn" @click="resetPassword(i)">重置密码</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				loginlist:[],
				login:{},
			}
		},
		methods:{
			deleteUser:function (i) {
				this.login = this.loginlist[i];
				this.$http.post(this.GLOBAL.base+'delLogin',this.login,{emulateJSON:true}).then(function (msg) {
					alert(msg.bodyText);
					this.getAllLogin();
				})
			},
			resetPassword:function (i) {
				this.login = this.loginlist[i];
				this.$http.post(this.GLOBAL.base+'resetPassword',this.login,{emulateJSON:true}).then(function (msg) {
					alert(msg.bodyText);
					this.getAllLogin();
				})
			},
			getAllLogin:function() {
				this.$http.get(this.GLOBAL.base+'getAllLogin').then(
					function(msg) {
						this.loginlist = msg.body;
					}
				)
			}
		},
		mounted() {
			this.getAllLogin();
		}
	}
</script>

<style>
	.userlist{
		padding: 15px;
		width: 100%;
		flex-wrap: wrap;
	}
	.user{
		width: 30%;
		height: 100px;
		background-color: white;
		margin-bottom: 15px;
		padding: 10px;
		margin-left: 3%;
	}
	.userleft,.usermiddle,.userright{
		height: 100%;
	}
	.usermiddle h5{
		padding-left: 10px;
	}
	
	.classone{
		color: lightseagreen;
	}
	
	.classtwo{
		color: #808080;
	}
</style>
